import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-canvas-obj-down",
  "use": "icon-canvas-obj-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-canvas-obj-down\"><path d=\"M544 806V168q0-14-9-23t-23-9-23 9-9 23v638L247 558q-10-10-23-10t-22.5 10.5T192 582t9 24l288 306q10 10 23 10t23-10l288-306q9-11 9-24t-9.5-23.5T800 548t-23 10z\" p-id=\"12146\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol